import { AppBar, type AppBarProps } from 'react-admin';
import { Box } from '@mui/material';
import { TitlePortal } from 'ra-ui-materialui';
import { DRAWER_WIDTH } from './theme';

const CustomAppBar = ({ children, alwaysOn, ...rest }: AppBarProps) => (
  <AppBar
    {...rest}
    alwaysOn={alwaysOn ?? true}
    container="div"
    position="fixed"
    color="inherit"
    elevation={0}
    sx={{
      borderBottom: '1px solid',
      borderColor: 'divider',
      width: { md: `calc(100% - ${DRAWER_WIDTH}px)` },
      ml: { md: `${DRAWER_WIDTH}px` },
      // From md up the title lines up with the pages' 32px gutter.
      '& .RaAppBar-toolbar': {
        minHeight: { xs: 56, sm: 64 },
        px: { xs: 2, md: 4 }
      },
      // The drawer is permanent from md up, so the toggle is for phones and tablets.
      '& .RaAppBar-menuButton': {
        display: { md: 'none' }
      }
    }}
  >
    <Box sx={{ flex: 1, minWidth: 0, display: 'flex', alignItems: 'center' }}>
      <TitlePortal variant="h2" component="h1" sx={{ typography: { xs: 'h6', sm: 'h2' } }} />
    </Box>
    {children}
    {/* Edit screens portal their save buttons in here. */}
    <Box
      id="appbar-actions"
      sx={{
        display: { xs: 'none', md: 'flex' },
        alignItems: 'center',
        gap: 1,
        mr: 1,
        '&:empty': {
          display: 'none'
        }
      }}
    />
  </AppBar>
);

export default CustomAppBar;
